export default "__VITE_ASSET__CEC53ZbO__$_?url__"